prismanoteApp.controller('retailerOtherGiftcardErrorModalController', ['$scope', '$uibModalInstance', '$rootScope', '$transaction', '$language', '$api', 'errors',
  function ($scope, $uibModalInstance, $rootScope, $transaction, $language, $api, errors) {

    $scope.errors = errors

    $scope.close = function () {
      $uibModalInstance.close()
    }
  }])